export default __webpack_public_path__ + "static/media/Contact_background.0694bcab.png";